import React, { useEffect, useState } from 'react';
import '../styles/ModalAuto.css';

function ModalAuto() {
    const [show, setShow] = useState(false);

    const MODAL_CLOSE_TIME_KEY = 'modalCloseTime';
    const MODAL_DISPLAY_INTERVAL = 24 * 60 * 60 * 1000; // 1 día en milisegundos

    useEffect(() => {
        const lastCloseTime = localStorage.getItem(MODAL_CLOSE_TIME_KEY);
        const now = new Date().getTime();

        if (!lastCloseTime || now - lastCloseTime > MODAL_DISPLAY_INTERVAL) {
            setShow(true);
        }
    }, [MODAL_DISPLAY_INTERVAL]);

    useEffect(() => {
        if (show) {
            // Bloquea scroll del fondo
            document.body.style.overflow = 'hidden';
        } else {
            // Restaura el scroll
            document.body.style.overflow = 'auto';
        }

        // Cleanup por seguridad al desmontar componente
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [show]);

    const handleClose = () => {
        setShow(false);
        localStorage.setItem(MODAL_CLOSE_TIME_KEY, new Date().getTime());
    };

    return (
        <>
            {show && (
                <div className="custom-overlay" onClick={handleClose}>
                    <div className="custom-overlay-content" onClick={(e) => e.stopPropagation()}>

                        {/* Botón X de cierre */}
                        <button
                            className="close-btn"
                            onClick={handleClose}
                            aria-label="Cerrar"
                        >
                            ✕
                        </button>

                        <picture>
                            <source srcSet="https://reymidascaps.s3.us-east-2.amazonaws.com/utils/ReyMidasPubliHome.webp" type="image/webp" />
                            <img
                                src="https://reymidascaps.s3.us-east-2.amazonaws.com/utils/ReyMidasPubliHome.webp"
                                alt="Información"
                                width="360"
                                height="auto"
                                loading="lazy"
                                decoding="async"
                                className="img-fluid rounded shadow-sm"
                            />
                        </picture>

                    </div>
                </div>
            )}
        </>
    );
}

export default ModalAuto;
